import { useEffect } from 'react'

import { keepPreviousData } from '@tanstack/react-query'

import { Assumption } from '@/services/models/assumptionSet/assumptions'
import { showError } from '@/utils/toast'
import { trpc } from '@/utils/trpc'

import useLastModifications from '../useLastModification'

type UseAssumptionsProps = {
  networkId: string
}

export const useAssumptions = ({ networkId }: UseAssumptionsProps) => {
  const { data: lastModifications } = useLastModifications(networkId)

  const {
    data: assumptions,
    isLoading,
    isError,
    isFetched,
    isPlaceholderData,
    refetch,
  } = trpc.assumptionSet.getAssumptions.useQuery<Assumption[]>(
    { networkId },
    {
      enabled: !!lastModifications?.assumption,
      placeholderData: keepPreviousData,
    },
  )

  useEffect(() => {
    if (isError) {
      showError('Failed to load assumptions', {
        description: 'Check your internet connection and try again',
      })
    }
  }, [isError])

  return { data: assumptions, isLoading, isFetched, isPlaceholderData, refetch }
}

export default useAssumptions
